import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  Toolbar,
  Tooltip,
  Button,
  TableRow,
  Paper,
  Checkbox,
  Collapse
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import Loading from "../../../loading";
import Snackbar from "../../../snackbar";
import EditCard from "../../../developerAccount/list/edit";
import { styles } from "./styles";
const headCells = [
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "developer_account_code",
  },
  {
    key: "username",
    numeric: false,
    disablePadding: false,
    label: "developer_account_username",
  },
  {
    key: "tag",
    numeric: false,
    disablePadding: false,
    label: "developer_account_tag",
  },
];

class DeveloperAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
    };
  }
  componentDidMount() {
    this.getListDeveloper();
  }
  getListDeveloper = async (payload) => {
    this.loading.startLoading();
    await this.props.getList(payload);
    this.loading.stopLoading();
  };
  finishUpdate = (result) => {
    if (result.code === 1) this.handleOpenCollapes(-1);
  };
  finishDelete = (result) => {
    if (result.code === 1) {
      this.handleOpenCollapes(-1);
      this.getListDeveloper();
    }
  };
  handleOpenCollapes = (id) => {
    const listDeveloper = this.props.listDeveloper;
    const collapse = this.state.collapse;
    for (var i = 0; i <= listDeveloper.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };
  renderCollapse = (row, index) => {
    const { classes, listDeveloper } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index} className={classes.tableCellInCollapes}>
        <TableCell
          colSpan={8}
          padding={"none"}
          className={classes.tableCellEdit}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditCard
              enableDelete={true}
              data={listDeveloper[index]}
              finishUpdate={this.finishUpdate}
              finishDelete={this.finishDelete}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const { t, listDeveloper, total, count, classes } = this.props;
    const { collapse = [] } = this.state;
    return (
      <div className={classes.root}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Table
          aria-labelledby="tableTitle"
        >
          <TableHead>
            <TableRow
              classes={{
                head: classes.customeHeadRow
              }}
            >
              {headCells.map((headCell) => (
                <TableCell
                  key={headCell.key}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "default"}
                  className={classes.customCell}
                >
                  <div>{t(headCell.label)}</div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
              {listDeveloper.map((row, index) => (
                [<TableRow hover key={index}>
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    className={classes.customCell}
                    onClick={() =>
                      this.handleOpenCollapes(index)
                    }
                  >
                    {row.code}
                  </TableCell>
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    className={classes.customCell}
                    onClick={() =>
                      this.handleOpenCollapes(index)
                    }
                  >
                    {row.username}
                  </TableCell>
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    className={classes.customCell}
                    onClick={() =>
                      this.handleOpenCollapes(index)
                    }
                  >
                    {row.tag}
                  </TableCell>
                </TableRow>,
                this.renderCollapse(row, index)
                ]
              ))}
          </TableBody>
        </Table>
        <div>
          <Toolbar className={classes.rootToolbar}>
            <div className={classes.spacer} />
            <div className={classes.actions}>
              <Tooltip title="Action">
                <Button
                  size="medium"
                  onClick={this.props.addNewAccount}
                  variant="contained"
                  color="primary"
                >
                  {t("create_developer_account_addbtn")}
                </Button>
              </Tooltip>
            </div>
          </Toolbar>
        </div>
      </div>
    );
  }
}

DeveloperAccount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listDeveloper: state.developerAccount.listDeveloper,
  total: state.developerAccount.total,
  count: state.developerAccount.count,
});
const mapDispatch = (dispatch) => ({
  getList: dispatch.developerAccount.getList,
  deletedeveloperAccount: dispatch.developerAccount.deletedeveloperAccount,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(DeveloperAccount)
  )
);
